<template>
  <b-overlay :show="loading">
    <b-card-actions action-collapse title="Daftar Ajuan Barang">
      <b-row class="align-items-end mb-1">
        <b-col md="2" sm="6" class="my-1">
          <b-form-group label="Per halaman" label-for="perPageSelect" class="mb-0">
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" sm="6" class="my-1">
          <b-form-group label="Status Ajuan" label-for="statusSelect" class="mb-0">
            <b-form-select
              id="statusSelect"
              v-model="selectedStatus"
              size="sm"
              :options="statusOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" sm="6" class="my-1">
          <b-form-group label="Cari" label-for="filterInput" class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Cari no ajuan / sales / keterangan..."
                @keyup.enter="applySearch"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="clearSearch">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="3" sm="6" class="my-1 d-flex justify-content-md-end">
          <b-button
            v-if="allowCreate() && isSales && myGudang"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            @click="add"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            Ajuan Barang
          </b-button>
        </b-col>
      </b-row>

      <b-modal
        v-if="allowCreate() || allowUpdate()"
        id="modal-ajuan-barang"
        v-model="showModal"
        no-close-on-backdrop
        no-close-on-esc
        centered
        title="Form Ajuan Barang"
        hide-footer
      >
        <validation-observer ref="formRequestbarang">
          <div class="d-flex mb-1">
            <feather-icon icon="PackageIcon" size="19" />
            <h6 class="ml-50 mb-0">Data Ajuan Barang</h6>
          </div>
          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Tanggal Ajuan" label-for="v-tanggal_waktu">
                  <validation-provider
                    #default="{ errors }"
                    name="tanggal_waktu"
                    rules="required"
                  >
                    <b-form-input
                      id="v-tanggal_waktu"
                      v-model="form.tanggal_waktu"
                      type="date"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col v-if="isSPV" cols="12">
                <b-form-group label="Pilih Sales" label-for="v-sales_id">
                  <validation-provider
                    #default="{ errors }"
                    name="sales_id"
                    :rules="{ required: true }"
                  >
                    <v-select
                      v-model="form.sales_id"
                      :options="sales_id"
                      label="text"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  v-if="userData && userData.level && userData.level.id == 7"
                  label="Pilih Sales"
                  label-for="v-sales_id_disabled"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="sales_id_disabled"
                    :rules="{ required: true }"
                  >
                    <b-form-select
                      id="v-sales_id_disabled"
                      v-model="form.sales_id"
                      :state="errors.length > 0 ? false : null"
                      :options="sales_id"
                      name="sales_id"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Pilih Rute" label-for="v-rute">
                  <validation-provider
                    #default="{ errors }"
                    name="rute"
                    rules="required"
                  >
                    <v-select
                      v-model="form.rutes"
                      label="text"
                      :options="routes"
                      multiple
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Keterangan" label-for="v-keterangan">
                  <b-form-textarea
                    id="v-keterangan"
                    v-model="form.keterangan"
                    placeholder="Isi Keterangan"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>

        <div class="d-flex justify-content-end align-items-center mt-2">
          <b-button
            size="sm"
            class="mr-1"
            variant="outline-secondary"
            :disabled="saving"
            @click="showModal = false"
          >
            Batal
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            :disabled="saving"
            @click.prevent="submit"
          >
            <b-spinner v-if="saving" small class="mr-50" />
            {{ saving ? "Menyimpan..." : id ? "Ubah" : "Simpan" }}
          </b-button>
        </div>
      </b-modal>

      <b-row>
        <b-col cols="12">
          <div
            v-if="!loading && !items.length"
            class="text-center text-muted py-4 border rounded"
          >
            Belum ada data ajuan barang
            <span v-if="filter"> untuk pencarian “{{ filter }}”</span>.
          </div>
          <b-table
            v-else
            striped
            small
            hover
            responsive
            :items="items"
            :fields="fields"
            show-empty
            empty-text="Tidak ada data"
          >
            <template #cell(i)="{ index }">
              {{ (currentPage - 1) * perPage + index + 1 }}
            </template>

            <template #cell(info)="{ item }">
              <a
                href="#"
                class="ajuan-info-link d-block text-body"
                @click.prevent="goDetail(item)"
              >
                <div class="ajuan-info-no">{{ item.no || "-" }}</div>
                <strong class="d-block ajuan-info-date">
                  {{ humanDate(item.tanggal_waktu) }}
                </strong>
                <small class="text-muted ajuan-info-meta">
                  {{ item.total_barang != null ? item.total_barang : 0 }} barang
                </small>
              </a>
            </template>

            <template #cell(diajukan_oleh)="{ item }">
              {{ getSalesLabel(item) }}
            </template>

            <template #cell(status)="{ item }">
              <b-badge
                :variant="
                  setStatus(item.status ?? item.status_data?.data_status).color
                "
              >
                {{
                  setStatus(item.status ?? item.status_data?.data_status).text
                }}
              </b-badge>
            </template>

            <template #cell(keterangan)="{ item }">
              {{ item.keterangan || "-" }}
            </template>

            <template #cell(actions)="row">
              <b-button
                v-if="allowUpdate()"
                v-b-tooltip.hover.right="isAjuanSelesai(row.item) ? 'Ajuan selesai tidak dapat diubah' : 'Ubah'"
                size="sm"
                class="mr-50"
                variant="outline-info"
                :disabled="isAjuanSelesai(row.item)"
                @click="edit(row.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-dropdown
                size="sm"
                variant="outline-secondary"
                right
                no-caret
                boundary="viewport"
              >
                <template #button-content>
                  <feather-icon icon="MoreVerticalIcon" />
                </template>
                <b-dropdown-item-button
                  @click="$router.push(`/ajuanbarang/detail/${row.item.id}`)"
                >
                  <feather-icon icon="EyeIcon" class="mr-50" />
                  Detail
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  v-if="isAdminGudang && !isSales && row.item.status == 4"
                  @click="downloadAttachment(row.item.id)"
                >
                  <feather-icon icon="FileTextIcon" class="mr-50" />
                  Surat Jalan
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  v-if="allowDelete()"
                  :disabled="isAjuanSelesai(row.item)"
                  @click="remove(row.item)"
                >
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  Hapus
                </b-dropdown-item-button>
              </b-dropdown>
            </template>
          </b-table>
        </b-col>

        <b-col
          cols="12"
          class="d-flex justify-content-between align-items-center mt-1"
        >
          <small class="text-muted">Total {{ totalRows }} data</small>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card-actions>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, confirmed, password } from "@validations";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm,
  BTable,
  VBTooltip,
  BBadge,
  BModal,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormTextarea,
  BOverlay,
  BSpinner,
  BDropdown,
  BDropdownItemButton,
} from "bootstrap-vue";

export default {
  components: {
    BForm,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BCardActions,
    BModal,
    BOverlay,
    BTable,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormTextarea,
    BSpinner,
    BDropdown,
    BDropdownItemButton,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      salesGudang: null,
      myMobil: null,
      myRute: null,
      routes: [],
      loading: false,
      saving: false,
      id: null,
      statusOptions: [
        { value: "all", text: "Semua", color: "light" },
        { value: 1, text: "PENDING", color: "danger" },
        { value: 2, text: "DISETUJUI SPV", color: "info" },
        { value: 3, text: "DISETUJUI GUDANG", color: "warning" },
        { value: 4, text: "SELESAI", color: "success" },
        { value: 5, text: "DIBATALKAN", color: "dark" },
      ],
      selectedStatus: "all",
      showModal: false,
      required,
      password,
      email,
      confirmed,
      form: {
        sales_id: "",
        retur_id: null,
        tanggal_waktu: new Date(),
        keterangan: "",
        rutes: [],
      },
      sales_id: [],
      userData: JSON.parse(localStorage.getItem("userData")),
      perPage: 10,
      pageOptions: [10, 30, 50, 100],
      totalRows: 0,
      currentPage: 1,
      filter: "",
      fields: [
        { key: "i", label: "No" },
        { key: "info", label: "Info" },
        { key: "diajukan_oleh", label: "Diajukan Oleh" },
        { key: "status", label: "Status" },
        { key: "keterangan", label: "Keterangan" },
        { key: "actions", label: "Aksi" },
      ],
      items: [],
    };
  },
  watch: {
    selectedStatus() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.fetchList();
    },
    perPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.fetchList();
    },
    currentPage() {
      this.fetchList();
    },
  },
  created() {
    this.form.tanggal_waktu = this.getCurrentDate();
  },
  async mounted() {
    await this.fetchList();
    this.getMyRoute();
    if (!this.isSales) {
      this.getsales_id();
    }
  },
  methods: {
    applySearch() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.fetchList();
    },
    clearSearch() {
      this.filter = "";
      this.applySearch();
    },
    fetchList() {
      if (this.isAdminGudang && !this.isSales) {
        return this.getDataGudang();
      }
      return this.getData();
    },
    async getSalesGudang() {
      const params = {
        karyawan_id:
          this.user && this.user.karyawan ? this.user.karyawan.id : null,
      };

      const myGudangs = await this.$store.dispatch("gudang/getData", params);
      if (!myGudangs || myGudangs.length < 1) {
        this.displayError({
          message: "Sales yang dipilih belum memiliki mobil penyimpanan!",
        });
      } else {
        this.salesGudang = myGudangs[0];
      }
    },
    async getRoute() {
      const params = {
        sales_id:
          this.user && this.user.karyawan ? this.user.karyawan.id : null,
      };
      const routes = await this.$store.dispatch("rute/getMyRouteJoin", params);
      this.routes = routes.map((item) => ({
        value: item.id,
        text: item.nama_rute,
      }));
    },
    async getMyRoute() {
      await this.getRoute();
      if (!this.user || !this.user.karyawan) return;

      const params = {
        karyawan_id: this.user.karyawan.id,
        jenis: 2,
      };

      const result = await this.$store.dispatch("gudang/getData", params);
      if (result && result.length > 0) {
        this.myRute = result[0].rute;
        this.myMobil = result[0];
        if (this.myRute) this.form.rute_id = this.myRute.id;
      }
    },
    async downloadAttachment(request_id) {
      const payload = {
        request_id,
        id_gudang: this.myGudang.id,
      };
      try {
        this.loading = true;
        await this.$store.dispatch("requestbarang/createSuratJalan", [payload]);

        const params = {
          request_id,
          gudangId: this.myGudang.id,
        };
        const response = await this.$store.dispatch(
          "requestbarang/printSuratJalan",
          params
        );
        this.loading = false;
        window.open(URL.createObjectURL(response));
      } catch (e) {
        this.loading = false;
        this.displayError(e);
        return false;
      }
    },
    setStatus(status) {
      const result = this.statusOptions.find((st) => st.value == status);
      return result || { color: "danger", text: "PENDING" };
    },
    getStatusCode(item) {
      if (!item) return null;
      const code = item.status ?? (item.status_data && item.status_data.data_status);
      return code != null ? Number(code) : null;
    },
    /** Status lifecycle 4 = SELESAI */
    isAjuanSelesai(item) {
      return this.getStatusCode(item) === 4;
    },
    getSalesLabel(item) {
      if (typeof item.sales === "string") {
        return item.sales || "-";
      }
      return item.sales && item.sales.nama_lengkap
        ? item.sales.nama_lengkap
        : "-";
    },
    goDetail(item) {
      if (!item || !item.id) return;
      this.$router.push(`/ajuanbarang/detail/${item.id}`);
    },
    async getRequestRoute(request_id) {
      const params = {
        request_id,
        sales_id:
          this.user && this.user.karyawan ? this.user.karyawan.id : null,
      };

      const requestRoute = await this.$store.dispatch(
        "requestbarang/getRoute",
        params
      );
      if (requestRoute.length > 0) {
        this.form.rutes = requestRoute.map((item) => ({
          id: item.id,
          text: item.rute ? item.rute.nama_rute : null,
          value: item.rute ? item.rute.id : null,
        }));
      }
    },
    async edit(item) {
      if (this.isAjuanSelesai(item)) {
        this.displayError({
          message: "Ajuan barang yang sudah selesai tidak dapat diubah",
        });
        return false;
      }
      this.form = { ...item };
      if (item.sales && typeof item.sales === "object") {
        const sales = this.sales_id.find((sl) => sl.id == item.sales.id);
        if (sales) {
          this.form.sales_id = {
            value: sales.id,
            id: sales.id,
            text: sales.nama_lengkap,
          };
        }
      }
      if (this.myRute) {
        this.form.rute_id = this.myRute.id;
      }
      if (this.form.tanggal_waktu) {
        this.form.tanggal_waktu = String(this.form.tanggal_waktu).split(" ")[0];
      }
      this.id = item.id;

      await this.getRequestRoute(this.id);
      this.showModal = true;
    },
    add() {
      this.resetForm();
      this.showModal = true;
    },
    remove(item) {
      if (this.isAjuanSelesai(item)) {
        this.displayError({
          message: "Ajuan barang yang sudah selesai tidak dapat dihapus",
        });
        return false;
      }
      this.$swal({
        title: "Anda yakin?",
        text: "Data ajuan barang ini akan dihapus",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((res) => {
        if (res.value) {
          const payload = {
            id: item.id,
            fungsi: 1,
          };
          this.$store
            .dispatch("requestbarang/save", [payload])
            .then(() => {
              this.fetchList();
              this.displaySuccess({
                message: "Ajuan berhasil dihapus",
              });
              this.resetForm();
            })
            .catch((e) => {
              this.displayError(e);
              return false;
            });
        }
      });
    },
    resetForm() {
      this.id = null;
      this.form = {
        sales_id: "",
        retur_id: null,
        tanggal_waktu: this.getCurrentDate(),
        keterangan: "",
        rutes: [],
      };
      if (this.myRute) {
        this.form.rute_id = this.myRute.id;
      }
    },
    submit() {
      if (this.saving) return false;
      this.$refs.formRequestbarang.validate().then(async (success) => {
        if (!success) return false;

        let salesId = this.form.sales_id;
        if (this.isSales) {
          salesId = this.user.karyawan.id;
        } else if (salesId && typeof salesId === "object") {
          salesId = salesId.id;
        }

        const payload = {
          ...this.form,
          sales_id: salesId,
        };

        if (this.id) {
          payload.id = this.id;
        }

        if (this.myGudang) {
          payload.id_gudang = this.myGudang.id;
        } else {
          const myGudangs = await this.$store.dispatch("gudang/getData", {
            karyawan_id: salesId,
          });
          payload.id_gudang =
            myGudangs && myGudangs.length > 0 ? myGudangs[0].id : null;
        }

        if (!payload.status) {
          payload.status = 1;
        }
        if (!payload.keterangan) {
          payload.keterangan = "-";
        }

        try {
          this.saving = true;
          const ajuan = await this.$store.dispatch("requestbarang/save", [
            payload,
          ]);
          if (payload.rutes && payload.rutes.length > 0) {
            const rutePayload = payload.rutes.map((item) => {
              const routeItem = {
                request_id: ajuan.id,
                sales_id:
                  this.user && this.user.karyawan
                    ? this.user.karyawan.id
                    : null,
                rute_id: item.value,
              };

              if (item.id) {
                routeItem.id = item.id;
              }

              return routeItem;
            });

            await this.$store.dispatch(
              "requestbarang/saveRoute",
              rutePayload
            );
          }
          if (this.isSales) {
            const key = "ajuan_barang";
            const value = {
              level: this.user.level.id,
              data: ajuan,
            };
            this.eventSocket(key, value);
          }
          this.showModal = false;
          this.$router.push(`/ajuanbarang/detail/${ajuan.id}`);
        } catch (e) {
          console.error(e);
          this.displayError(e);
          return false;
        } finally {
          this.saving = false;
        }
      });
    },
    buildListParams(extra = {}) {
      const params = {
        order: "desc",
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
        ...extra,
      };

      if (this.selectedStatus && this.selectedStatus !== "all") {
        params.status = this.selectedStatus;
      }
      if (this.filter && String(this.filter).trim() !== "") {
        params.search = String(this.filter).trim();
      }

      return params;
    },
    async getDataGudang() {
      if (!this.myGudang || !this.myGudang.id) {
        this.items = [];
        this.totalRows = 0;
        return;
      }

      const params = this.buildListParams({
        gudang_id: this.myGudang.id,
      });

      this.loading = true;
      try {
        const ajuans = await this.$store.dispatch(
          "requestbarang/getDataGudang",
          params
        );
        this.items = Array.isArray(ajuans) ? ajuans : [];
        this.totalRows = ajuans && ajuans.total != null ? ajuans.total : this.items.length;
      } catch (e) {
        this.displayError(e);
        this.items = [];
        this.totalRows = 0;
      } finally {
        this.loading = false;
      }
    },
    async getData() {
      const params = this.buildListParams(
        this.isSales && this.user && this.user.karyawan
          ? { sales_id: this.user.karyawan.id }
          : {}
      );

      this.loading = true;
      try {
        const ajuans = await this.$store.dispatch(
          "requestbarang/getData",
          params
        );
        this.items = Array.isArray(ajuans) ? ajuans : [];
        this.totalRows =
          ajuans && ajuans.total != null ? ajuans.total : this.items.length;
      } catch (e) {
        this.displayError(e);
        this.items = [];
        this.totalRows = 0;
      } finally {
        this.loading = false;
      }
    },
    getsales_id() {
      this.$store
        .dispatch("karyawan/getData", {})
        .then(() => {
          const karyawan = JSON.parse(
            JSON.stringify(this.$store.state.karyawan.datas)
          );
          karyawan.map((item) => {
            item.value = item.id;
            item.text = item.nama_lengkap;
          });
          this.sales_id = karyawan;
        })
        .catch((e) => {
          this.displayError(e);
          return false;
        });
    },
  },
};
</script>

<style scoped>
.ajuan-info-link {
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s ease;
}
.ajuan-info-link:hover,
.ajuan-info-link:hover .ajuan-info-no,
.ajuan-info-link:hover .ajuan-info-date,
.ajuan-info-link:hover .ajuan-info-meta {
  color: #7367f0 !important;
  text-decoration: none;
}
</style>
